import axios from "axios";
import {
  CREATE_USER_ROLE_FAIL,
  CREATE_USER_ROLE_SUCCESS,
  CREATE_USER_ROLE_REQUEST,
  DELETE_USER_ROLE_FAIL,
  DELETE_USER_ROLE_REQUEST,
  DELETE_USER_ROLE_SUCCESS,
  GET_USER_ROLE_FAIL,
  GET_USER_ROLE_REQUEST,
  GET_USER_ROLE_SUCCESS,
  UPDATE_USER_ROLE_FAIL,
  UPDATE_USER_ROLE_REQUEST,
  UPDATE_USER_ROLE_SUCCESS,
} from "../../types/admin/userRoleTypes";

export const createUserRoleAction =
  (formData) => async (dispatch, getState) => {
    try {
      dispatch({
        type: CREATE_USER_ROLE_REQUEST,
      });
      const {
        sharedLogin: { sharedUserInfo },
      } = getState();

      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `${sharedUserInfo?.payload?.token}`,
        },
      };
      let companyId;
      if (sharedUserInfo?.payload?.company) {
        companyId = sharedUserInfo?.payload?.company?._id;
      } else if (sharedUserInfo?.empCompanies.length > 0) {
        companyId = sharedUserInfo?.empCompanies[0]?.companyId?._id;
      }
      const { data } = await axios.post(
        `${process.env.REACT_APP_BACKEND_URI}/api/admin/${companyId}/userAccess/insert`,
        formData,
        config
      );
      // console.log({ data });
      dispatch({
        type: CREATE_USER_ROLE_SUCCESS,
        payload: data?.data,
      });
    } catch (error) {
      let err =
        error.response &&
        (typeof error.response.data === "string"
          ? error.response.data
          : error.response.data.message
          ? error.response.data.message
          : error.response.data.errors
          ? error.response.data.error[0].msg
          : error.message);
      if (!err) {
        err = "Network Error";
      }
      dispatch({
        type: CREATE_USER_ROLE_FAIL,
        payload: err,
      });
      throw err;
    }
  };

export const updateUserRoleAction =
  (formData) => async (dispatch, getState) => {
    try {
      dispatch({
        type: UPDATE_USER_ROLE_REQUEST,
      });
      const {
        sharedLogin: { sharedUserInfo },
      } = getState();

      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `${sharedUserInfo?.payload?.token}`,
        },
      };
      let companyId;
      if (sharedUserInfo?.payload?.company) {
        companyId = sharedUserInfo?.payload?.company?._id;
      } else if (sharedUserInfo?.empCompanies.length > 0) {
        companyId = sharedUserInfo?.empCompanies[0]?.companyId?._id;
      }
      const { data } = await axios.post(
        `${process.env.REACT_APP_BACKEND_URI}/api/admin/${companyId}/userAccess/insert`,
        formData,
        config
      );
      // console.log({ data });
      dispatch({
        type: UPDATE_USER_ROLE_SUCCESS,
        payload: data?.data,
      });
    } catch (error) {
      let err =
        error.response &&
        (typeof error.response.data === "string"
          ? error.response.data
          : error.response.data.message
          ? error.response.data.message
          : error.response.data.errors
          ? error.response.data.error[0].msg
          : error.message);
      if (!err) {
        err = "Network Error";
      }
      dispatch({
        type: UPDATE_USER_ROLE_FAIL,
        payload: err,
      });
      throw err;
    }
  };

export const getUserRoleAction = () => async (dispatch, getState) => {
  try {
    dispatch({
      type: GET_USER_ROLE_REQUEST,
    });
    const {
      sharedLogin: { sharedUserInfo },
    } = getState();

    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `${sharedUserInfo?.payload?.token}`,
      },
    };
    let companyId;
    if (sharedUserInfo?.payload?.company) {
      companyId = sharedUserInfo?.payload?.company?._id;
    } else if (sharedUserInfo?.empCompanies.length > 0) {
      companyId = sharedUserInfo?.empCompanies[0]?.companyId?._id;
    }
    const { data } = await axios.get(
      `${process.env.REACT_APP_BACKEND_URI}/api/admin/${companyId}/userAccess`,
      config
    );
    // console.log({ data });
    dispatch({
      type: GET_USER_ROLE_SUCCESS,
      payload: data?.data,
    });
  } catch (error) {
    let err =
      error.response &&
      (typeof error.response.data === "string"
        ? error.response.data
        : error.response.data.message
        ? error.response.data.message
        : error.response.data.errors
        ? error.response.data.error[0].msg
        : error.message);
    if (!err) {
      err = "Network Error";
    }
    dispatch({
      type: GET_USER_ROLE_FAIL,
      payload: err,
    });
    throw err;
  }
};

export const deleteUserRoleAction = (id) => async (dispatch, getState) => {
  try {
    dispatch({
      type: DELETE_USER_ROLE_REQUEST,
    });
    const {
      sharedLogin: { sharedUserInfo },
    } = getState();

    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `${sharedUserInfo?.payload?.token}`,
      },
    };

    let companyId;
    if (sharedUserInfo?.payload?.company) {
      companyId = sharedUserInfo?.payload?.company?._id;
    } else if (sharedUserInfo?.empCompanies.length > 0) {
      companyId = sharedUserInfo?.empCompanies[0]?.companyId?._id;
    }

    const { data } = await axios.post(
      `${process.env.REACT_APP_BACKEND_URI}/api/admin/${companyId}/userAccess/delete`,
      { id },
      config
    );
    // console.log({ data });
    dispatch({
      type: DELETE_USER_ROLE_SUCCESS,
      payload: data?.data,
    });
  } catch (error) {
    let err =
      error.response &&
      (typeof error.response.data === "string"
        ? error.response.data
        : error.response.data.message
        ? error.response.data.message
        : error.response.data.errors
        ? error.response.data.error[0].msg
        : error.message);
    if (!err) {
      err = "Network Error";
    }
    dispatch({
      type: DELETE_USER_ROLE_FAIL,
      payload: err,
    });
    throw err;
  }
};
